module.exports = __webpack_public_path__ + "img/ticket3_b.e432d28f.svg";